import type { TransactionOrderRole } from '@shared/transactions-types';

import type { TransactionPredicate } from './types';

export const hasOrderRole =
    (role: TransactionOrderRole): TransactionPredicate =>
    ({ orderRole }) =>
        Boolean(orderRole) && orderRole === role;
